import { useEffect, useState } from "react";
import { Button } from "./ui/button";
import { Cookie, X } from "lucide-react";
import { getConsent, setConsent, analyticsAvailable } from "../lib/analytics";

export default function ConsentBanner() {
  const [consent, setC] = useState(() => getConsent());
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (analyticsAvailable() && !consent) setVisible(true);
    const onChange = () => setC(getConsent());
    window.addEventListener("consent-changed", onChange);
    return () => window.removeEventListener("consent-changed", onChange);
  }, [consent]);

  if (!visible || consent) return null;

  function accept() {
    setConsent("accepted");
    setC("accepted");
    setVisible(false);
  }
  function reject() {
    setConsent("rejected");
    setC("rejected");
    setVisible(false);
  }

  return (
    <div
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:max-w-md z-50 rounded-2xl p-5 shadow-lg border"
      style={{ background: "var(--surface)", borderColor: "var(--border-subtle)", boxShadow: "0 20px 40px -12px rgba(0,0,0,0.25)" }}
      data-testid="consent-banner"
      role="dialog"
      aria-label="Cookie consent"
    >
      <div className="flex items-start gap-3">
        <div className="h-9 w-9 rounded-lg flex items-center justify-center shrink-0" style={{ background: "color-mix(in srgb, var(--primary) 15%, transparent)" }}>
          <Cookie className="h-5 w-5" style={{ color: "var(--primary)" }} />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-display font-bold tracking-tight">Cookies & analytics</h3>
          <p className="text-sm mt-1" style={{ color: "var(--text-muted)" }}>
            VeriHandi uses privacy-respecting analytics (anonymized IP) to understand how tools are used. You can accept or reject. Essential cookies (login session, preferences) are always on. See our <a href="/privacy" className="underline">privacy notice</a>.
          </p>
          <div className="flex gap-2 mt-4">
            <Button onClick={reject} variant="outline" data-testid="consent-reject" className="flex-1">Reject</Button>
            <Button onClick={accept} data-testid="consent-accept" className="flex-1 text-white" style={{ background: "var(--primary)" }}>Accept</Button>
          </div>
        </div>
        <button onClick={reject} className="p-1 rounded hover:bg-[color:var(--surface-2)]" aria-label="Dismiss" data-testid="consent-close">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
